module.exports = __webpack_public_path__ + "static/media/veneto-village-21.02a63733.jpg";